import React from 'react'
import './OrganizationDescription.css'

const OrganizationDescription = () => {
  return null
}
export default OrganizationDescription